module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")])]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Папки",
      "hint": "Структура папок видна только для пользователей депонента",
      "items": _vm.getDisplayPaths(),
      "item-value": "key",
      "item-text": "value"
    },
    model: {
      value: (_vm.itemId),
      callback: function($$v) {
        _vm.itemId = $$v
      },
      expression: "itemId"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a82c974","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/depo/FolderSelector.vue
// module id = 1178
// module chunks = 1